module.exports = __webpack_public_path__ + "img/processing.ef793969.svg";